
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Werner K., 66 ans, décédé le 8 novembre 2020</b>
    <br />
    <br />
    <i>Sa fille raconte:</i>
    <br />
    <p>
  «Notre famille a toujours eu confiance dans les mesures sanitaires prises par
  le Conseil fédéral. C’était le cas avant la mort de mon père, et c’est
  toujours le cas. Nous n’avons pas apprécié la controverse autour du respect de
  ces règles. Certains pensent même qu’il faut désormais vivre avec la mort. Ils
  estiment que c’est un phénomène naturel. D’autres générations ont connu la
  guerre. J’ai de la peine à comprendre ces points de vue. Ils ne vont pas
  soulager notre souffrance. Les morts ne sont pas interchangeables. Il ne faut
  pas les opposer. Chaque cas est particulier. Pour nous, la perte de notre père
  a été une expérience terrible. Il était âgé de 66 ans, mais il aurait pu être
  plus jeune ou plus vieux. L’âge ne compte pas lorsque vous perdez un être
  cher.
    </p>
    <p>
  Le coronavirus est une maladie contre laquelle nous pouvons nous protéger,
  contrairement au cancer ou à une crise cardiaque. Mais nous pouvons le faire
  uniquement si tout le monde soutient les mesures sanitaires du Conseil
  fédéral.
    </p>
    <p>
  Notre système de santé est fragilisé par cette pandémie. Lorsque mon père est
  tombé malade, il n’a pas pu aller à l’hôpital. L’établissement était
  surchargé, il n’accueillait que les personnes en situation de détresse
  respiratoire. Cette situation est douloureuse pour tout le monde: les
  patients, la famille, le personnel soignant. Cela ne devrait pas avoir lieu
  dans un pays comme la Suisse.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;